import { render, staticRenderFns } from "./app-left-tag.vue?vue&type=template&id=6b4b38aa&scoped=true&"
import script from "./app-left-tag.vue?vue&type=script&lang=js&"
export * from "./app-left-tag.vue?vue&type=script&lang=js&"
import style0 from "./app-left-tag.vue?vue&type=style&index=0&id=6b4b38aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4b38aa",
  null
  
)

export default component.exports